import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { createPart } from '../../../../redux/api/partsApi';
import { createVisitPartAction } from '../../../../redux/actions/visitPartsActions';
import { convertToVisitPartRequest } from '../../../../utils/requestMapper';
import Button from '../../../shared/buttons/Button';
import Modal from '../../../shared/modal/Modal';
import VisitPartForm from '../forms/VisitPartForm';

const CreateVisitPartModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit.visit);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);

    if (data.partName) {
      const { error, data: newPart } = await createPart({ name: data.partName, price: data.partPrice });
      if (error) {
        toast.error(error?.message || 'Не вдалося створити деталь');
        setLoading(false);
        return;
      }
      data.part = { id: newPart.id };
    }

    const part = convertToVisitPartRequest(data);
    await dispatch(createVisitPartAction(vin, id, part));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати деталь'}
      loading={loading}
      onClose={onModalClose}
      body={
        <VisitPartForm readOnly={false} onSubmit={onSubmit} loading={loading} part={{ count: 1, isCritical: false }} />
      }
      actionButton={
        <Button
          type={'submit'}
          disabled={loading}
          variant={'primary'}
          formId={'visitPart-form'}
          children={'Зберегти'}
        />
      }
    />
  );
};

export default CreateVisitPartModal;
